if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.modalClose = this.querySelector('[id^="ModalClose-"]');

        // Define elements to hide as class properties
        this.elementsToHideDesktop = [
          '.product-form__buttons .shopify-payment-button',
          '.product__text',
          '.product__title',
          '.price__container',
          '.page-width.breadcrumbs-snippet',
          'variant-selects legend.form__label',
          '.product-form__quantity',
          '.product__view-details',
          '.product .product__media-wrapper',
          '.price--show-badge',
          '.product-popup-modal__opener',
          '.share-button__button',
          '[id^="price-quickadd-template-"]',
          '[id^="Quantity-Form-quickadd-template-"]',
        ];

        this.elementsToHideMobile = [
          '.product-form__buttons .shopify-payment-button',
          'variant-selects legend.form__label',
          '.product-form__quantity',
          '.product__text',
          '.page-width.breadcrumbs-snippet',
          '.product__view-details .icon-arrow',
        ];

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });

        // Prevent clicks inside modal from bubbling up
        this.modalContent.addEventListener('click', (event) => {
          event.stopPropagation();
        });
        this.modalClose.addEventListener('click', (event) => {
          event.stopPropagation();
        });

        // Handle clicks outside modal
        document.addEventListener('click', (event) => {
          if (this.hasAttribute('open')) {
            // Check if the click is outside both the modal content and the cart drawer
            const cartDrawer = document.querySelector('cart-drawer');
            const isClickInCart = cartDrawer && cartDrawer.contains(event.target);
            const isClickInModal = this.modalContent.contains(event.target);
            
            if (!isClickInModal && !isClickInCart) {
              this.hide();
            }
          }
        });
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );
            const productElement = responseHTML.querySelector('product-info');

            const isMobile = window.innerWidth <= 989;

            if (!isMobile) {
              // On desktop, append the modal under the opener element
              if (!opener.contains(this)) {
                opener.appendChild(this);
              }

              this.elementsToHideDesktop.forEach((selector) => {
                const elements = productElement.querySelectorAll(selector);
                if (elements.length > 0) {
                  elements.forEach((element) => {
                    element.style.display = 'none';
                  });
                }
              });
            } else {
              // On mobile, ensure the modal remains in its current behavior
              if (!document.body.contains(this.modalContent)) {
                document.body.appendChild(this.modalContent);
              }
              this.elementsToHideMobile.forEach((selector) => {
                const elements = productElement.querySelectorAll(selector);
                if (elements.length > 0) {
                  elements.forEach((element) => {
                    element.style.display = 'none';
                  });
                }
              });
              
              const productTitle = productElement.querySelector('.product__title');
              const price = productElement.querySelector('.price__container');
              const viewDetails = productElement.querySelector('.product__view-details');

              if (productTitle || price || viewDetails) {
                const wrapper = document.createElement('div');
                wrapper.className = 'quick-add-mobile-header';
                if (productTitle) wrapper.appendChild(productTitle);
                if (price) wrapper.appendChild(price);
                if (viewDetails) wrapper.appendChild(viewDetails);

                // Find the product and media wrapper nodes
                const productNode = productElement.querySelector('.page-width .product');
                const mediaGridItem = productNode?.querySelector('.grid__item.product__media-wrapper');

                if (productNode && mediaGridItem) {
                  const mediaHeaderWrapper = document.createElement('div');
                  mediaHeaderWrapper.className = 'quick-add-mobile-media-header';
                  // Insert the new wrapper before the original mediaGridItem
                  productNode.insertBefore(mediaHeaderWrapper, mediaGridItem);
                  // Move mediaGridItem and header into the new wrapper
                  mediaHeaderWrapper.appendChild(mediaGridItem);
                  mediaHeaderWrapper.appendChild(wrapper);
                } else {
                  productElement.insertBefore(wrapper, productElement.firstChild);
                }
              }
            }
            this.modalContent.classList.add('maccabi-tlv');


            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              productElement.outerHTML
            );

            // Update add to cart button classes
            const addToCartBtn = this.modalContent.querySelector('.product-form__submit');
            if (addToCartBtn) {
              addToCartBtn.className = 'product-form__submit button button--full-width button--primary';
              const ctaSpan = addToCartBtn.querySelector('span');
              if (ctaSpan) {
                const iconImg = document.createElement('img');
                iconImg.src = addToCartBtn.getAttribute('data-icon-url') || 'https://cdn.shopify.com/s/files/1/0757/2350/5889/files/tabler-icon-arrow-narrow-left.svg?v=1746683025';
                iconImg.alt = 'icon';
                iconImg.className = 'button-icon';
                ctaSpan.insertAdjacentElement('afterend', iconImg);
              }
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            if (window.innerWidth > 989) {
              document.body.classList.remove('overflow-hidden');
            }
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);

        // Hide all specified elements after every update
        const isMobile = window.innerWidth <= 989;
        const elementsToHide = isMobile ? this.elementsToHideMobile : this.elementsToHideDesktop;

        elementsToHide.forEach((selector) => {
          const elements = productElement.querySelectorAll(selector);
          if (elements.length > 0) {
            elements.forEach((element) => {
              element.style.display = 'none';
            });
          }
        });
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector(
          'pickup-availability'
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(
          oldId,
          newId
        );
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(
              attribute.name,
              attribute.value.replace(oldId, newId)
            );
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) =>
          img.setAttribute('sizes', mediaImageSizes)
        );
      }
    }
  );
}
